import React from 'react';
import { Box, Container, Skeleton, Typography } from '@mui/material';

const MenuSkeleton: React.FC = () => (
  <Box sx={{
    minHeight: '100vh',
    width: '100vw',
    background: '#f6f6f8',
    paddingTop: 'calc(env(safe-area-inset-top, 0px) + 24px)',
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    paddingLeft: 'env(safe-area-inset-left, 0px)',
    paddingRight: 'env(safe-area-inset-right, 0px)',
    fontFamily: 'Inter, system-ui, sans-serif' 
  }}>
    <Container maxWidth={false} disableGutters sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 1, maxWidth: '100%', mx: 'auto' }}>
      {/* Header Image Skeleton */}
      <Skeleton 
        variant="rectangular" 
        width="100%" 
        height={190} 
        sx={{ 
          borderRadius: '8px', 
          mb: 1.5,
          boxShadow: '0 1px 4px rgba(60,72,100,0.06)' 
        }} 
      />

      {/* Categories Section Skeleton */}
      <Box sx={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 1000, 
        background: '#f6f6f8', 
        pt: 1,
        pb: 0.5,
        width: '100%'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, px: 0, alignSelf: 'flex-start', color: '#181818', fontSize: '1.08rem', letterSpacing: '-0.5px', mt: 0.5 }}>
          Categorías
        </Typography>
        
        {/* Category tabs skeleton */}
        <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
          {[1, 2, 3, 4].map((item) => (
            <Skeleton 
              key={item}
              variant="rounded" 
              width={80} 
              height={32} 
              sx={{ borderRadius: '999px' }}
            />
          ))}
        </Box>

        {/* Divider */}
        <Box sx={{ width: '100%', height: 1, background: '#ececec', mb: 0.5 }} />
      </Box>

      {/* Menu Items Section Skeleton */}
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.2, px: 0, alignSelf: 'flex-start', color: '#181818', fontSize: '1.08rem', letterSpacing: '-0.5px', mt: 0.5 }}>
        Artículos del Menú
      </Typography>

      {/* Menu items skeleton */}
      <Box sx={{ width: '100%', mt: 1 }}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <Box key={item} sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="rectangular" width={80} height={80} sx={{ borderRadius: '8px' }} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="90%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="40%" height={20} />
            </Box>
            <Skeleton variant="rounded" width={60} height={32} sx={{ borderRadius: '8px' }} />
          </Box>
        ))}
      </Box>
    </Container>
  </Box>
);

export default MenuSkeleton; 